module.exports = __webpack_public_path__ + "manzama-logotype-dark-56702f8a28e371c491759e0adb85d45a.svg";